import React from 'react';
import InputGroup from '../../InputGroup';

import { Field } from 'redux-form';

const PostalCodeInput = () => (
    <Field
        name="postalCode"
        placeholder="Postal Code"
        component={InputGroup}
        type="text"
        label="Postal Code"
        maxLength={10}
        autocomplete="billing postal-code"
    />
);

export default PostalCodeInput;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/PostalCodeInput.jsx